<div class="new-registration-overlay-page">
  <div class="overlay-header">
    <h2>New Contractor Registration</h2>

    <button type="button" class="close-btn" (click)="closeOverlay()">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="overlay-body">
    <h1 class="page-heading">
      Select a contractor type to start the registration process
    </h1>

    <div *ngIf="isLoading" class="loading-text">
      Loading contractor registration workflows...
    </div>

    <div
      *ngIf="!isLoading && contractorRegistrationWorkflows.length === 0"
      class="empty-text"
    >
      No contractor registration workflows available.
    </div>

    <div
      class="contractor-type-scroll-container"
      *ngIf="!isLoading && contractorRegistrationWorkflows.length > 0"
    >
      <wm-common-radio
        [data]="contractorTypeRadioData"
        (valueChange)="onContractorTypeChange($event)"
      >
      </wm-common-radio>
    </div>
  </div>

  <div class="overlay-footer">
    <button type="button" class="cancel-btn" (click)="closeOverlay()">
      CANCEL
    </button>

    <button
      type="button"
      class="start-btn"
      [disabled]="!selectedWorkflow || isStarting"
      (click)="startApplication()"
    >
      {{ isStarting ? 'STARTING...' : 'START' }}
    </button>
  </div>
</div>
